import { MessageCircle, CreditCard, FileCheck, Truck } from 'lucide-react';

const steps = [
  {
    icon: MessageCircle,
    title: '1. Sipariş',
    text: 'Sepetinizi onaylayın; sipariş kaydı oluşur.',
  },
  {
    icon: CreditCard,
    title: '2. Havale bilgisi',
    text: 'WhatsApp’ta IBAN ve tutar iletilir. Kart ile ödeme alınmaz.',
  },
  {
    icon: FileCheck,
    title: '3. Dekont',
    text: 'Ödeme dekontunu aynı WhatsApp sohbetinden gönderin.',
  },
  {
    icon: Truck,
    title: '4. Kargo',
    text: 'Onay sonrası Yurtiçi Kargo ile gönderilir.',
  },
];

export function HavaleTrustBlock({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`rounded-lg border border-green-200 bg-green-50 ${compact ? 'p-4' : 'p-6'}`}>
      <h3 className={`font-bold text-gray-900 mb-1 ${compact ? 'text-base' : 'text-lg'}`}>
        Güvenli Havale / EFT Ödeme
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        Ödeme sitede alınmaz. Banka bilgileri yalnızca WhatsApp mesajında paylaşılır.
      </p>
      <div className={`grid gap-3 ${compact ? 'sm:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-4'}`}>
        {steps.map((step) => {
          const Icon = step.icon;
          return (
            <div key={step.title} className="flex gap-3 bg-white/80 rounded-lg p-3 border border-green-100">
              <div className="size-9 shrink-0 rounded-full bg-green-100 flex items-center justify-center">
                <Icon className="size-4 text-green-700" />
              </div>
              <div>
                <div className="text-sm font-semibold text-gray-900">{step.title}</div>
                <p className="text-xs text-gray-600 leading-snug mt-0.5">{step.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
